import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ROUTES } from '@constants/routes';

type InviteRelativesButtonProps = {
  label: string;
  icon: IconDefinition;
  className?: string;
};

export const InviteRelativesButton = ({ label, icon, className }: InviteRelativesButtonProps) => {
  const navigate = useNavigate();

  return (
    <Button
      variant='primary'
      type='button'
      className={classNames('d-inline-flex align-items-center gap-2', className)}
      onClick={() => navigate(ROUTES.FVT_INVITE)}
    >
      <FontAwesomeIcon icon={icon} aria-hidden='true' />
      {label}
    </Button>
  );
};
